import styled from "@emotion/styled";
import Link from "next/link";

import { fontRoboto, fontRobotoCondensed, theme } from "shared/lib/styles";

import BookmarksIconSvg from "./icon_bookmark.svg";

export const Container = styled.div`
  position: relative;

  display: flex;
  flex-direction: column;
  gap: 24px;

  inline-size: 335px;
  margin-block: 0;
  margin-inline: auto;

  ${theme.breakpoints.up("tablet")} {
    margin-inline: 0;
  }

  ${theme.breakpoints.up("desktop")} {
    inline-size: 300px;
  }
`;

export const Title = styled.div`
  flex-grow: 1;

  font-weight: 700;
  font-size: 14px;
  font-family: ${fontRobotoCondensed};
  line-height: 16px;
  text-transform: uppercase;
`;
export const TitleContainer = styled.div`
  display: flex;
  gap: 10px;
  justify-content: space-between;
  align-items: center;

  padding-block-end: 8px;

  border-block-end: 1px solid #dddddd;
`;

export const ManageButton = styled(Link)`
  color: #4585ff;
  font-weight: 400;
  font-size: 14px;
  font-family: ${fontRoboto};
  font-style: normal;
  line-height: normal;
  text-align: center;

  background: none;

  cursor: pointer;
`;

export const StyledBookmarksIconSvg = styled(BookmarksIconSvg)``;

export const EmptyBookmark = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  inline-size: 100%;
  block-size: 220px;

  color: #000000;
  font-weight: 400;
  font-size: 14px;
  font-family: ${fontRoboto};
  font-style: normal;
  line-height: normal;
  text-align: center;

  border: 1px dashed #bbbbbb;
`;
